import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = (event) => {
    // Only open on successful cart additions (not errors)
    if (event.detail?.data?.didError === true) {
      return;
    }

    // Don't open for quantity updates within the cart drawer
    // Only open for actual product additions
    const source = event.detail?.data?.source;
    if (source === 'cart-items-component') {
      return;
    }

    // Variant modal "Buy now" adds to cart then redirects to checkout; do not open the drawer
    if (source === 'variant-modal-buy-now') {
      return;
    }

    // Check if drawer is already open - showDialog() already handles this,
    // but we check here to avoid unnecessary timeout
    if (this.refs.dialog?.open) {
      return;
    }

    // Add a slight delay to ensure cart state is fully updated
    // This gives time for cart sections to update before opening the drawer
    setTimeout(() => {
      // Double-check drawer is still closed before opening
      if (!this.refs.dialog?.open) {
        this.showDialog();
      }
    }, 200);
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
